import { render } from "./News-Details.vue?vue&type=template&id=cd6ff642&scoped=true"
import script from "./News-Details.vue?vue&type=script&lang=js"
export * from "./News-Details.vue?vue&type=script&lang=js"

import "./News-Details.vue?vue&type=style&index=0&id=cd6ff642&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cd6ff642"

export default script